module.exports = __webpack_public_path__ + "img/firewall-2.ddc073b0.webp";